import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaLinkedinIn,
  FaPinterestP,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const socials = [
  { icon: FaFacebookF,  label: "Facebook",  href: "#" },
  { icon: FaInstagram,  label: "Instagram", href: "#" },
  { icon: FaTiktok,     label: "TikTok",    href: "#" },
  { icon: FaXTwitter,   label: "X",         href: "#" },
  { icon: FaYoutube,    label: "YouTube",   href: "#" },
  { icon: FaLinkedinIn, label: "LinkedIn",  href: "#" },
  { icon: FaPinterestP, label: "Pinterest", href: "#" },
  { icon: FaWhatsapp,   label: "WhatsApp",  href: "#" },
];

/**
 * Full-width site footer with dark navy background.
 * @param {string} clubName  - e.g. "Leo Club"
 * @param {string} boardYear - e.g. "2026/27"
 */
const Footer = ({ clubName, boardYear }) => (
  <footer className="relative z-10 w-full bg-[#000000] text-gray-500 mt-16 border-t border-white/5">

    {/* ── Main Content ── */}
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">

      {/* Column 1 — Club Info */}
      <div>
        <div className="flex items-center gap-3 mb-4">
          <img
            src={process.env.PUBLIC_URL + '/club.png'}
            alt="Leo Club logo"
            className="w-10 h-10 rounded-lg object-contain"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <div>
            <p className="text-white font-bold text-base leading-tight">
              {clubName} of SLIIT
            </p>
            <p className="text-[#D4AF37] text-xs font-medium">
              Lions International, District 306 D6
            </p>
          </div>
        </div>

        <p className="text-sm leading-relaxed text-gray-500 mb-5">
          Fueling leadership. Empowering youth. {clubName} of SLIIT stands tall
          as a trailblazer in Leo District 306 D6 and Leo Multiple District 306,
          delivering years of impact, innovation, and excellence. Join the pride
          that shapes tomorrow!
        </p>

        <p className="text-xs text-gray-600">
          &copy; 2017–{new Date().getFullYear()} {clubName} of SLIIT.
        </p>
      </div>

      {/* Column 2 — Reach Us */}
      <div>
        <h4 className="text-white font-bold text-base mb-5">Reach Us</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start gap-3">
            <FaPhoneAlt className="text-gray-400 mt-0.5 shrink-0" />
            <span>WhatsApp: +94 78 633 6363</span>
          </li>
          <li className="flex items-start gap-3">
            <FaEnvelope className="text-gray-400 mt-0.5 shrink-0" />
            <a
              href="mailto:info@sliitleo.org"
              className="hover:text-white transition-colors"
            >
              info@sliitleo.org
            </a>
          </li>
          <li className="flex items-start gap-3">
            <FaMapMarkerAlt className="text-gray-400 mt-0.5 shrink-0" />
            <span>{clubName} of SLIIT, Malabe</span>
          </li>
        </ul>
      </div>

      {/* Column 3 — Socials */}
      <div>
        <h4 className="text-white font-bold text-base mb-5">Socials</h4>
        <div className="flex flex-wrap gap-4">
          {socials.map(({ icon: Icon, label, href }) => (
            <a
              key={label}
              href={href}
              aria-label={label}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#D4AF37] transition-colors duration-200 text-lg"
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>
    </div>

    {/* ── Bottom Bar ── */}
    <div className="border-t border-white/5 py-6 text-center text-xs text-gray-600">
      All Rights Reserved. Redesigned and Developed by{' '}
      <span className="text-[#D4AF37] font-semibold">
        IT Dept. of {clubName} of SLIIT
      </span>
      .
    </div>
  </footer>
);

export default Footer;
